import { getTranslations } from 'next-intl/server';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { HomeProductCarousel } from '@headless-workspace/domain/common/client';
import {
    AsyncComponent,
    EcomConfigKeys,
    getCachedEcomConfigByKey,
    TileProductValue,
} from '@headless-workspace/domain/common/server';
import { GlowCarouselProps, PropsWithClassName, PropsWithLocale } from '@headless-workspace/glow-ds';

type ProductCarouselContainerProps = PropsWithLocale &
    PropsWithClassName &
    Pick<GlowCarouselProps, 'navigationButtonClassName' | 'removeMarginAtViewport'> & {
        products: TileProductValue[];
    };

export const ProductCarouselContainer: AsyncComponent<ProductCarouselContainerProps> = async ({
    locale,
    className,
    navigationButtonClassName,
    products,
    removeMarginAtViewport,
}) => {
    const enablePriceLegalMentionsResult = await getCachedEcomConfigByKey(
        locale,
        EcomConfigKeys.EnablePriceLegalMentions,
    );

    if (products.length === 0) {
        return null;
    }

    const t = await getTranslations('Discover.Home.carousel');

    const enablePriceExceptionLegalMentions = unwrapResultSuccess(enablePriceLegalMentionsResult) ?? false;

    return (
        <HomeProductCarousel
            removeMarginAtViewport={removeMarginAtViewport}
            className={className}
            products={products}
            wishlistBtnAriaLabel={t('ariaLabel.wishlist')}
            locale={locale}
            navigationButtonClassName={navigationButtonClassName}
            enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
        />
    );
};
